export enum FeatureFlagKeys {
  APP_SHOW_E_INVOICING_NUDGE = 'app-show-einvoicing-nudge',
  APP_ENABLE_SKIPPING_E_INVOICING_NUDGE = 'app-enable-skipping-einvoicing-nudge',
}
